export const vHighlight = {
  mounted(el, binding) {
    const productAllStore = useManagementProductAllStore()

    // Önceki ve yeni değeri saklamak için
    let oldValue = binding.value

    // Watch effect oluştur
    const stop = watch(
      [() => binding.value, () => productAllStore.isRevisionView],
      ([newValue, isRevisionView], [oldValue]) => {
        if (isRevisionView && newValue !== oldValue) {
          el.classList.add('highlight-change')
          setTimeout(() => {
            el.classList.remove('highlight-change')
          }, 2000)
        }
      },
      { deep: true }
    )

    // Component unmount olduğunda watch'ı temizle
    el._stopHighlightWatch = stop
  },

  unmounted(el) {
    // Watch'ı temizle
    if (el._stopHighlightWatch) {
      el._stopHighlightWatch()
    }
  }
}
